// A swan, modelled facing +X: a white body, a tall curved neck, a small head and
// an orange bill. Ported 1:1 from age-of-mcp's classic swan.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.IcosahedronGeometry(0.05, 0), color: "#fbfcfd",
      position: [0, 0.028, 0], scale: [1.7, 0.95, 1.05] },          // body
    // S-curved neck — three stacked segments.
    { geometry: new THREE.CylinderGeometry(0.011, 0.014, 0.04, 5), color: "#fbfcfd",
      position: [0.06, 0.06, 0], rotation: [0, 0, -0.5] },
    { geometry: new THREE.CylinderGeometry(0.009, 0.011, 0.04, 5), color: "#fbfcfd",
      position: [0.085, 0.095, 0], rotation: [0, 0, 0.2] },
    { geometry: new THREE.IcosahedronGeometry(0.016, 0), color: "#ffffff",
      position: [0.092, 0.12, 0] },                                  // head
    { geometry: new THREE.ConeGeometry(0.008, 0.022, 4), color: "#e06820",
      position: [0.112, 0.116, 0], rotation: [0, 0, -Math.PI / 2] },   // bill
    { geometry: new THREE.IcosahedronGeometry(0.006, 0), color: "#16140f",
      position: [0.088, 0.13, 0] },                                  // knob
    { geometry: new THREE.ConeGeometry(0.016, 0.04, 4), color: "#f4f6f8",
      position: [-0.062, 0.04, 0], rotation: [0, 0, Math.PI / 2 + 0.6] }, // raised tail
  ];
}

export const swan = defineModel({
  id: "swan",
  scale: 2.72, // real-world size correction (see Model.scale)
  batchId: "standard",
  name: "Swan",
  tags: ["creature","swan","low-poly","age-of-mcp","classic","water"],
  summary: "Low-poly swan.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.1,
  parts: () => partsFor(),
  animations: [],
});
